import { initReactI18next } from 'react-i18next';
import { use } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import { env } from '@/env';

export default use(HttpApi)
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    load: 'languageOnly',
    fallbackLng: 'de',
    detection: {
      order: ['querystring', 'cookie', 'navigator'],
      caches: ['cookie'], // cache user language on
    },
    debug: true, // disable for console spam
    supportedLngs: ['de', 'en'],
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    backend: {
      queryStringParams: {
        v: env.VITE_RELEASE_VERSION
      }
    }
  });
